import React from "react";
import ErrorIcon from "@material-ui/icons/Error";
import { isEmpty, find, isPlainObject, forIn } from 'lodash';
import moment from "moment";

const DEFAULT_VALUE_AUTOCOMPLETE = { value: "", label: ""};

export const findElementIntoArray = (array, keyField, value) =>
  array ? array.find((obj) => {
        return obj[keyField] === value;
    }) : [];

const getDefaultValueByType = (field, version) => {
  const defaultValues = {
    "autocomplete": version && parseInt(version) ? DEFAULT_VALUE_AUTOCOMPLETE : "",
    "select": field?.multiple ? [] : "",
    "default": ""
  }
   return defaultValues[field.type] || defaultValues.default;
}

export const arrayFieldsToObject = (
    arrayFields,
    keyField,
    formValues,
    version
) =>
    arrayFields.reduce((obj, field) => {
        const a = formValues
            ? findElementIntoArray(formValues, "id", field.id)
            : getDefaultValueByType(field.field.type, version);
        obj[field[keyField]] = a
            ? { value: a.value, textValue: a.textValue, extraValues: a.extraValues, type: a.type }
            : { value: getDefaultValueByType(field.field, version), textValue: "", extraValues: {}, type: field.field.type};
        return obj;
    }, {});

export const getFormAnswers = (stateFormAnswers, questions, version, state, isThereDefaultValues) =>
  questions.map((question) => {
    let value = "";
    let textValue = "";
    let extraValues = {};

    value = stateFormAnswers[question.id]?.value || getDefaultValueByType(question.field.type, version);
    textValue = stateFormAnswers[question.id]?.textValue || "";
    extraValues = stateFormAnswers[question.id]?.extraValues || {};

    if (question.fieldReference && state) { // Validation to get the value from other field
      const [ group, fieldId ] = question.fieldReference.split(".");
      if(state.answers[group]) {
        const field = findElementIntoArray(state.answers[group], "id", fieldId);
        if (field && !isEmpty(field)) {
          value = field.value;
          textValue = field.textValue;
          extraValues = field.extraValues;
        }
      }
    } else if (isThereDefaultValues) { // If there is a default value
      if (!value) { // If there is not an answer, we use the default value
        // If field doesn't have default value, we use intial value.
        value = question.field.defaultValue || value;
        textValue = question.field.defaultValue || textValue;
      }
    }

      return {
          id: question.id,
          label: question.label,
          name: question.name,
          group: question.group,
          position: question.position,
          type: question.field.type,
          required: question.required,
          disabled: question.disabled,
          value,
          textValue,
          extraValues,
          showOnSummary: question.field.showOnSummary,
          summaryLabel: question.summaryLabel || "",
          maskType: question.field.maskType || "",
          multiple: question.field.multiple || false,
          class: question.class,
          open: question.field.open || false,
          descriptionSkedulo: question.field.descriptionSkedulo || false
      };
  });

export const getAnswersFromInitialValues = (questions, version, answers) => {
  if(isEmpty(questions)) return [];

  const isThereDefaultValues = find(questions, (q) => { return q.field.defaultValue });

  if(!isThereDefaultValues && !answers) return [];

  const objAnswers = arrayFieldsToObject(questions, "id", answers, version);
  return getFormAnswers(objAnswers, questions, version, undefined, isPlainObject(isThereDefaultValues));
}

export const cuestionsByGroupInOrderAsc = (questions, group) =>
  questions.filter((question) => question.group === group)
        .sort((a, b) => {
            if (parseInt(a.position) > parseInt(b.position)) {
                return 1;
            }
            if (parseInt(a.position) < parseInt(b.position)) {
                return -1;
            }
            return 0;
        });

export const orderGroupsByElementAsc = (groups, element) =>
  groups.sort((a, b) => {
    const aOrder = parseInt(a[element]) || 99;
    const bOrder = parseInt(b[element]) || 99;
      if (aOrder > bOrder) {
          return 1;
      }
      if (aOrder < bOrder) {
          return -1;
      }
      return 0;
  });

export const replaceStringFromObject = (stringWithValues, obj) => {
  var Strings = {
    create : (function() {
            var regexp = /{([^{]+)}/g;
            // eslint-disable-next-line
            return function(str, o) {
              return str.replace(regexp, function(ignore, key){
                return (key = o[key]) == null ? '' : key;
              });
            }
    })()
  };
  // example: Strings.create("My firstname is {first}, my last name is {last}", {first:'Neo', last:'Andersson'})
  return Strings.create(stringWithValues, obj)
}

export const getContactError = (storeContact) => {
  if(storeContact) {
      return `Please send an e-mail to ${storeContact?.email || ""} ${storeContact?.phone && `or contact us at ${storeContact?.phone}`} for assistance.` ;
  } else {
      return `Please contact us for assistance.`;
  }

};

export const getEligibilityQuestions = (validationData, eligibilityQuestions = []) => {
  let fields = [],
      ids = new Set(),
      serviceProviders = validationData[0]?.verification?.serviceproviders;

  if (!serviceProviders) {
      return eligibilityQuestions;
  }
  for (const [type, utilities] of Object.entries(serviceProviders)) {
      let fieldValues = [],
          typeLabel = type[0].toUpperCase() + type.slice(1);
      ids.add(`${type}Utility`);
      if (!Array.isArray(utilities)) {
          continue;
      }
      utilities.forEach(utility => {
          fieldValues.push(
              {
                  label: utility.providername,
                  value: utility.providerid
              }
          )
      });
      fields.push({
          field: {
              values: fieldValues,
              errorMessages: ["This field is required"],
              type: "select",
              validators: ["required"]
          },
          group: "eligibility",
          required: true,
          id: `${type}Utility`,
          label: `${typeLabel} Utility?`,
          name: `${type}Utility`
      })
  }
  return [...fields, ...eligibilityQuestions.filter(field => !ids.has(field.id))];
}

export const getImageFileType = (type) => {
  const typesArray = [".png", ".PNG", ".jpg", ".JPG", ".jpeg", ".JPEG"];
  return typesArray.includes(type) ? true : false;
}

export const generateGroupClasses = (sections) => {
let valuesByClass = {};
  forIn(sections, function(group) {
    forIn(group, function(answers) {
      answers.forEach((answer) => {
        const arrAnswers = valuesByClass[answer.class] || [];
        valuesByClass[answer.class] = [...arrAnswers, answer]
      })
    })
  });
  return valuesByClass;
}

export const sortGroups = groups => {
  if (groups) {
    return groups.sort((a, b) => {
          if (Number(a.position) > Number(b.position)) {
              return 1;
          }
          if (Number(a.position) < Number(b.position)) {
              return -1;
          }
          return 0;
        });
  } else {
    return [];
  }
};

export const QontoStepIcon = () => <ErrorIcon color="secondary" />;

export const calculateDate = (date, format = "MM/DD/YYYY") => { //currently this function operates only under moment library scope and the current date
  const dateType = typeof(date);
  let newDate;

  switch (dateType) {
    case 'string': //If the date type is an string will return the same value as it gets
      newDate = date;

      break;
    case 'object': //If the date type is an object will calculate and return a new date depending on the sent params
      const { operation, amount, time } = date;
      //operation: tell us what we are going to do with the date, in the current time this function supports only two operations add or substract certein amount of time, that tie will be dictated by the following fields
      //amount: tell us how much time we will add or subtract to the date
      //time: specify what kind of time we will operate (i.e. hours, days, months...)
      if(operation.toLowerCase() === 'add') 
        newDate = moment().add(amount, time).format(format);
      else if(operation.toLowerCase() === 'subtract')
        newDate = moment().subtract(amount, time).format(format);
      else //If the function gets an unidentified operation will return the current date
        newDate = moment().format(format);
      //after made any operation we need to format our new date
      break;
    default: //If the date type is neither the types above will return the current date
      newDate = moment().format(format);

      break;
  }

  return newDate;
};

export const truncateString = (string = '', length = 5) => {
  return (string && typeof string !== 'boolean')
      ? `${string.replace(/\D/g, '').substring(0, length)}`
      : string;
};